import { StringParam, useQueryParams } from 'use-query-params';

type IUseUtmQueryParams = {
  utm: {
    utm_source?: string;
    utm_medium?: string;
    utm_campaign?: string;
    utm_term?: string;
    utm_content?: string;
  };
};

export const useUtmQueryParams = (): IUseUtmQueryParams => {
  const [utm] = useQueryParams({
    utm_source: StringParam,
    utm_medium: StringParam,
    utm_campaign: StringParam,
    utm_term: StringParam,
    utm_content: StringParam,
  });

  return {
    utm: {
      utm_source: utm.utm_source ?? undefined,
      utm_medium: utm.utm_medium ?? undefined,
      utm_campaign: utm.utm_campaign ?? undefined,
      utm_term: utm.utm_term ?? undefined,
      utm_content: utm.utm_content ?? undefined,
    },
  };
};
